import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { ValidationResultsModule } from '../../shared/components/validation-results/validation-results.module';
import { SharedModule } from '../../shared/shared.module';
import { SharedValidatorsModule } from '../../shared/validators/shared-validators.module';
import { ServiceHistoryComponent } from './service-history.component';
import { ServiceHistoryResultsComponent } from './service-history-results.component';

@NgModule({
    declarations: [
        ServiceHistoryComponent,
        ServiceHistoryResultsComponent
    ],
    providers: [],
    imports: [
        CalendarModule,
        CommonModule,
        DropdownModule,
        SharedModule,
        SharedValidatorsModule,
        TableModule,
        ValidationResultsModule
    ],
    exports: [
        ServiceHistoryComponent,
        ServiceHistoryResultsComponent
    ]
})

export class ServiceHistoryModule { }
